// Storage per device and per player (localStorage). Versions and migrations: save.ts
import { SAVE } from './save';

// ---------- Storage (per device, per player) ----------
export interface Profile { id: string; prog: Record<string, { stars: number; duck: boolean }>; fails?: Record<string, number>; intros?: Record<string, number>; ch?: { animal: string; shirt: string; shoes: string }; [k: string]: unknown }
export interface StoreData { profiles: Profile[]; cur: string | null; settings: { hintAlways: boolean; sound: boolean; music: boolean; testAll?: boolean; [k: string]: unknown }; unlocked: boolean; [k: string]: unknown }
export const Store = {
  key: SAVE.KEY, d: null as unknown as StoreData,
  load() {
    let d: object | null = null, from = 0;
    try { ({ d, from } = SAVE.load(localStorage)); } catch (e) {}
    this.d = Object.assign({ profiles: [], cur: null, settings: { hintAlways: false, sound: true, music: true }, unlocked: false }, d || {});
    this.d.settings = Object.assign({ hintAlways: false, sound: true, music: true }, this.d.settings);
    if (from && from < SAVE.VERSION) this.save();   // save in the new version (the old key is left in place)
  },
  save() { try { localStorage.setItem(this.key, JSON.stringify(this.d)); } catch (e) {} },
  prof(): Profile | null { return this.d.profiles.find(p => p.id === this.d.cur) || null; },
};
Store.load();
